import React, { Component } from 'react';
import './Dashboard.css';
import { CustomNav } from '../Components/CustomNav';
import { apiServerUrl } from '../config';
import { requestOptions } from '../_helpers';
import axios from 'axios';
import { userActions } from '../_actions';
import { connect } from 'react-redux';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUser: {}
    };
    this.toggleActive = this.toggleActive.bind(this);
  }
  componentDidMount() {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/user_info', requestOptions())
      .then(function(response) {
        ////console.log("compenen mount respone " + JSON.stringify(awayTeam));
        //const teamsData = React.createContext(response);
        //console.log(response.data);
        currentComponent.setState({
          selectedUser: response.data
        });
      })
      .catch(function(error) {
        //console.log(error);
      });
  }
  toggleActive(e, example) {
    // reset login status
    this.props.dispatch(userActions.logout());
    window.location.reload();
  }

  render() {
    return (
      <div>
        <CustomNav />
        <div style={{ justifyContent: 'center' }}>
          <div
            style={{
              background: 'white',
              padding: '3em',
              margin: '3em auto',
              width: '33%',
              border: '3px solid #778189',
              borderRadius: '3px'
            }}
          >
            <p>Username: {this.state.selectedUser.username}</p>
            <p>Email: {this.state.selectedUser.email}</p>
            <p>Organization: {this.state.selectedUser.organization}</p>
            {/*<p>
              Password: {this.state.selectedUser.password}
            </p>*/}
            <button
              className="header-account-button"
              onClick={this.toggleActive}
            >
              LOGOUT
            </button>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const connectedAccount = connect(mapStateToProps)(Account);
export { connectedAccount as Account };

//export default Account;



// WEBPACK FOOTER //
// ./src/Pages/Account.js